import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllAcademies, modifyAcademy } from "./academiesAPI";

const initialState = {
    value: [],
    status: "idle",
    editStatus: "idle",
};

export const retrieveAcademies = createAsyncThunk("academies/getAllAcademies", async() => {
    const response = await getAllAcademies();
    return response;
});

export const editAcademy = createAsyncThunk(
    "academies/modifyAcademy",
    async(data) => {
        const response = await modifyAcademy(data);
        return response;
    }
);

export const academiesSlice = createSlice({
    name: "academies",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        modify: (state, action) => {
            var newData = state.value.map((academy) => {
                if (academy.id === action.payload.id)
                    return Object.assign({}, academy, action.payload);
                return academy;
            });
            state.value = newData;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [retrieveAcademies.pending]: (state, action) => {
            state.status = "loading";
        },
        [retrieveAcademies.fulfilled]: (state, action) => {
            state.status = "succeeded";
            if (action.payload.message){
                if (action.payload.message === "Unathorized"){
                    state.value = []
                }
            } else {
                state.value = action.payload;
            }
        },
        [retrieveAcademies.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },
        [editAcademy.pending]: (state, action) => {
            state.editStatus = "loading";
        },
        [editAcademy.fulfilled]: (state, action) => {
            state.editStatus = "succeeded";
            // Add any fetched posts to the array
            if (action.payload.message){
                if (action.payload.message === "Unathorized"){
                    state.value = []
                }
            } else {
                state.value = action.payload;
            }
        },
        [editAcademy.rejected]: (state, action) => {
            state.editStatus = "failed";
            state.error = action.error.message;
        },
    },
});

export const { modify } = academiesSlice.actions;

export const selectAllAcademies = (state) => state.academies.value;

export default academiesSlice.reducer;